import { useLocation } from 'react-router-dom'
import { useScheduleDetails } from '@/features/scheduleDetails/useScheduleDetails'
import { isPulseBrowsePath } from '@/routes/pulseBrowsePaths'
import HomeNavModeTabs from './components/HomeNavModeTabs'
import HomeNavRailPanes from './components/HomeNavRailPanes'
import { useHomeNavModeSwitch } from './components/useHomeNavModeSwitch'
import { useHomeNavThreadGroups } from './components/useHomeNavThreadGroups'
import styles from './components/HomeNavRail.module.scss'

export default function HomeNavRail(ctx) {
  const { pathname } = useLocation()
  const groups = useHomeNavThreadGroups(ctx.threads, ctx.pinnedThreadIds ?? [])
  const schedule = useScheduleDetails()
  const { mode, onChange } = useHomeNavModeSwitch(isPulseBrowsePath(pathname), {
    onPulse: ctx.onPulse,
    onChat: ctx.onNewChat,
  })

  return (
    <div className={styles.rail}>
      <HomeNavModeTabs value={mode} onChange={onChange} />
      <HomeNavRailPanes mode={mode} ctx={ctx} groups={groups} schedule={schedule} />
    </div>
  )
}
